import { useContext } from 'react';
import { __RouterContext as RouterContext } from 'react-router';
import { RouteComponentProps, StaticContext } from 'react-router';
import * as H from 'history';

// HACK: react-router still doesn't expose a native hook :/
export default function useRouter<
  Params extends { [K in keyof Params]?: string } = {},
  C extends StaticContext = StaticContext,
  S = H.LocationState
>() {
  // @ts-ignore
  return useContext(RouterContext) as RouteComponentProps<Params, C, S>;
}
